import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { usePageBg } from '../shared/usePageBg';
import { usePageBgGradient } from '../shared/usePageBgGradient';
import HeroSection from './HeroSection/HeroSection';
import TryItOut from './TryItOut/TryItOut';
import Workflow from './Workflow/Workflow';
import WebReport from './WebReport/WebReport';
import BusinessTools from './BusinessTools/BusinessTools';
import Proof from './Proof/Proof';
import Comparison from './Comparison/Comparison';
import Pricing from './Pricing/Pricing';
import InternachiPricing from './Pricing/InterNachiPricing';
import Download from './Download/Download';
import AboutUs from './AboutUs/AboutUs';

interface MainContentProps {
  isMobile: boolean;
  isTablet: boolean;
  setToastMessage: (message: string) => void;
  setShowToast: (showToast: boolean) => void;
  openWaitlist?: () => void;
}

const MainContent: React.FC<MainContentProps> = ({
  isMobile,
  setToastMessage,
  setShowToast,
  openWaitlist,
}) => {
  const location = useLocation();
  const isInternachi = location.pathname.startsWith(
    '/InterNACHI-discount-ji394su3pa7',
  );

  usePageBg();
  usePageBgGradient();

  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (!hash) return;
      const id = hash.split('?')[0].substring(1);
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    };
    const t = setTimeout(scrollToHash, isMobile ? 300 : 100);
    return () => clearTimeout(t);
  }, [location, isMobile]);

  return (
    <main className="main-content">
      {process.env.REACT_APP_API_URL?.includes('dev.') && (
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
      )}
      {isInternachi ? (
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
      ) : (
        <Helmet>
          <title>AI Home Inspection Software for Inspectors | Morph</title>
          <meta
            name="description"
            content="AI home inspection software that turns photos and voice notes into a finished inspection report on-site, in 3 clicks — leave the property with the report done."
          />
          <link rel="canonical" href="https://www.morph-technologies.com/" />
        </Helmet>
      )}
      <HeroSection />
      <TryItOut
        setToastMessage={setToastMessage}
        setShowToast={setShowToast}
        openWaitlist={openWaitlist}
      />
      <Workflow />
      <WebReport />
      <BusinessTools />
      <Proof />
      <Comparison />
      {isInternachi ? <InternachiPricing /> : <Pricing />}
      <Download />
      <AboutUs />
    </main>
  );
};

export default MainContent;
